module.exports = __webpack_public_path__ + "img/048-storm-4.05bb7ffd.svg";